<div *ngIf="showBanner && subscription">

  <div *ngIf="!subscription?.on_trial && !subscription?.subscribed" class="pointer-events-none fixed inset-x-0 bottom-0 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8 z-50">
    <div class="pointer-events-auto flex items-center justify-between gap-x-6 bg-secondary px-6 py-2.5 sm:rounded-xl shadow-lg sm:py-3 sm:pl-4 sm:pr-3.5">
      <p class="text-sm leading-6 text-primary-100">
        You don't have an active subscription. Subscribe to get full access to all features.
      </p>

      <button type="button" (click)="openBillingPortal()" class="whitespace-nowrap text-sm font-semibold text-primary-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-transparent">Buy Subscription</button>

      <button type="button" (click)="closeBanner()" class="-m-1.5 flex-none p-1.5">
        <span class="sr-only">Dismiss</span>
        <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
        </svg>
      </button>
    </div>
  </div>

  <div *ngIf="subscription?.on_trial && subscription?.credits === 0" class="pointer-events-none fixed inset-x-0 bottom-0 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8 z-50">
    <div class="pointer-events-auto flex items-center justify-between gap-x-6 bg-secondary px-6 py-2.5 sm:rounded-xl shadow-lg sm:py-3 sm:pl-4 sm:pr-3.5">
      <p class="text-sm leading-6 text-primary-100">
        You don't have any credits left, please buy a new subscription.
      </p>
      <button type="button" (click)="openBillingPortal()" class="whitespace-nowrap text-sm font-semibold text-primary-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-transparent">Buy Subscription</button>

      <button type="button" (click)="closeBanner()" class="-m-1.5 flex-none p-1.5">
        <span class="sr-only">Dismiss</span>
        <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
        </svg>
      </button>

    </div>
  </div>

  <div *ngIf="!subscription?.on_trial && subscription?.subscribed && subscription?.credits === 0" class="pointer-events-none fixed inset-x-0 bottom-0 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8 z-50">
    <div class="pointer-events-auto flex items-center justify-between gap-x-6 bg-secondary px-6 py-2.5 sm:rounded-xl shadow-lg sm:py-3 sm:pl-4 sm:pr-3.5">
      <p class="text-sm leading-6 text-primary-100">
        You don't have any credits left, please buy a new subscription.
      </p>
      <button type="button" (click)="openBillingPortal()" class="whitespace-nowrap text-sm font-semibold text-primary-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-transparent">Buy Subscription</button>

      <button type="button" (click)="closeBanner()" class="-m-1.5 flex-none p-1.5">
        <span class="sr-only">Dismiss</span>
        <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
        </svg>
      </button>

    </div>
  </div>

</div>